import Changelog from './changelog';

export default Changelog;
